import styled from 'styled-components';
import { NATIVE_TABBAR_SPACE, mediaQuery, modalFooterHeight, paddings } from '~/styled';

export const ModalActionDiv = styled.div<{ $infoOrErrorOrWarning?: boolean }>`
  height: ${modalFooterHeight};
  display: flex;
  align-items: center;
  padding: ${paddings.defaultPadding} ${paddings.medium2xPadding};
  box-sizing: border-box;
  justify-content: flex-start;
  width: 100%;
  ${mediaQuery.down.s`
  button{
    flex-grow: 1;
    flex-basis: 0;
    test-align: center;
    height:48px;
    &>div{
    justify-content: center;
    }
  }
  `}

  ${({ $infoOrErrorOrWarning }) =>
    !$infoOrErrorOrWarning &&
    mediaQuery.down.s`
  height: calc(${modalFooterHeight} + ${NATIVE_TABBAR_SPACE});
  padding-bottom: calc(${paddings.defaultPadding} + ${NATIVE_TABBAR_SPACE});
  `}

  ${({ $infoOrErrorOrWarning }) =>
    $infoOrErrorOrWarning &&
    mediaQuery.down.s`
  padding: 0 ${paddings.largePadding};
  align-items: center;
  justify-content: flex-end;
  button{
    margin-left: ${paddings.defaultPadding};
    width:auto;
    flex:unset;
    height:auto;
    }
    `}

${mediaQuery.up.s`
    align-items: center;
    justify-content: flex-end;
    padding:${paddings.defaultPadding} ${paddings.largePadding};
    button{
      margin-left: ${paddings.defaultPadding};
       padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export const ActionContainerMessage = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
  ${mediaQuery.down.s`
    display:none;
  `}
`;

export const ActionBtnsContainer = styled.div`
  width: max-content;
`;
